export default {
  cs: {
    settings: 'nastavení',
    select: 'vybrat',
    'cancel-select': 'zrušit výběr',
    scheduler: 'plánovač',
    monday: 'pondělí',
    tuesday: 'úterý',
    wednesday: 'středa',
    thursday: 'čtvrtek',
    friday: 'pátek',
    saturday: 'sobota',
    sunday: 'neděle',
    devices: 'zařízení',
    service: 'služba',
    edit: 'upravit',
    done: 'hotovo',
    'service-groups': 'skupiny služeb',
    dashboard: 'hlavní panel',
    'scene-settings': 'nastavení scény',
    'scenes-settings': 'nastavení scény',
    scenes: 'scény',
    preferences: 'preference',
    'add-scene': 'přidat scénu',
    'scene-name': 'název scény',
    'scene-icon': 'ikonka scény',
    'add-service': 'přidat službu',
    'remove-scene': 'odebrat scénu',
    'edit-scene': 'upravit scénu',
    'remove-service': 'odebrat službu',
    'add-vizualization': 'přidat vizualizaci',
    'remove-vizualization': 'odebrat vizualizaci',
    vizualization: 'vizualizace',
    vizualizations: 'vizualizace',
    'vizualization-name': 'název vizualizace',
    'vizualization-file': 'soubor vizualizace',
    'drop-file-here': 'přetáhni sem soubor',
    'choose-a-file': 'vyber soubor',
    'no-vizualizations': 'žádné vizualizace',
    'add-service-or-device': 'přidat službu nebo zařízení',
    'enable-edit-mode': 'zapnout editační mód',
    'disable-edit-mode': 'vypnout editační mód',
    remove: 'odebrat',
    notifications: 'notifikace',
    logging: 'logování',
    graphs: 'grafy',
    value: 'hodnota',
    'turned-on': 'zapnuto',
    'turned-off': 'vypnuto',
    running: 'běží',
    'not-running': 'neběží',
    warnings: 'upozornění',
    'are-you-sure-you-want-remove': 'opravdu odebrat',
    'my-profile': 'můj profil',
    'manage-users': 'správa uživatelů',
    'licence-and-services': 'licence a služby',
    'plc-connection-settings': 'připojení k PLC',
    'turn-on': 'zapnout',
    'turn-off': 'vypnout',
    from: 'z',
    'users-management': 'správa uživatelů',
    account: 'účet',
    'user-permissions': 'uživatelská oprávnění',
    'add-user': 'přidat uživatele',
    'service-scheduler': 'týdenní kalendář',
    'request-form-text': 'vaše požadavky vkládejte prostřednictvím tohoto formuláře a obratem obdržíte e-mailem odkaz pro sledování řešení Vašeho požadavku.',
    'request-subject': 'předmět požadavku',
    'issue-type': 'zvolte typ požadavku',
    'issue-description': 'detailní popis požadavku',
    description: 'popis',
    question: 'dotaz',
    bug: 'chyba',
    'change-request': 'požadavek na úpravu',
    problem: 'problém',
    sended: 'odesláno',
    'helpdesk-message': 'zpráva technické podpoře',
    'type subject of issue': 'napiště předmět požadavku',
    'write what happened': 'napiš co jsi zjistil',
    send: 'odeslat',
    'select-option': 'vyber jednu z možností',
    'sending-error': 'chyba při odesílání',
    'change-project': 'změnit projekt',
    loading: 'načítání',
    selected: 'vybráno',
    place: 'místo',
    group: 'skupina',
    icon: 'ikona',
    name: 'název',
    choose: 'vybrat',
    'include-devices': 'zahrnout zařízení',
    'user-settings': 'nastavení uživatele',
    'charts-and-values': 'hodnoty a grafy',
    'menu-notifications': 'upozornění',
    techsupport: 'technická podpora',
    'menu-change-project': 'změna projektu',
    favorite: 'oblíbené',
    'enable-push-notifications': 'povolit push notifikace',
    'first-name': 'jméno',
    'last-name': 'příjmení',
    username: 'uživatelské jméno',
    email: 'email',
    phone: 'telefon',
    password: 'heslo',
    'choose-language': 'vybrat jazyk',
    'enable-devices': 'povolit zařízení',
    'is-superuser': 'je superuživatel',
    'user-update': 'nastavení uživatele',
    error: 'chyba',
    saved: 'uloženo',
    'add-next': 'přidat další',
    close: 'zavřít',
    save: 'uložit',
    logout: 'odhlásit se',
    delete: 'smazat',
    show: 'zobrazit',
    permissions: 'oprávnění',
    'enable-email-notifications': 'povolit notifikace na email',
    appearance: 'zobrazení',
    'show-devices': 'zobrazit zařízení',
    'starting-screen': 'úvodní obrazovka',
    'enable-advance-level': 'povolit advance režim',
    'enable-instaler-level': 'povolit instaler režim',
    'show-advance-level': 'přejít do advance režimu',
    'show-instaler-level': 'přejít do instaler režimu',
    'form-contains-errors': 'formulář obsahuje chyby',
    'passwords-do-not-match': 'hesla se neshodují',
    'repeat-password': 'opakuj heslo',
    'password-change': 'změna hesla',
    'choose-services-to-giving-permission': 'vyber služby, pro udělení oprávnění',
    'access-control': 'úroveň oprávnění',
    'user-has-no-permissions': 'uživatel nemá žádné oprávnění',
    add: 'přidat',
    'starting-visualization-is': 'startovací vizualizace je',
    'not-set': 'nenastaveno',
    'choose-visualization': 'vyber vizualizaci',
    'there-is-no-visualizations': 'žádná dostupná vizualizace',
    'update-visualization': 'úprava vizualizace',
    'set-as-default': 'nastaveno jako výchozí',
    services: 'služby',
    'edit-permissions': 'nastavení práv',
    'user-create': 'vytvoření uživatele',
    share: 'sdílet',
    'share-to-user': 'sdílet',
    deselect: 'zrušit výběr',
    sharing: 'sdílení',
    set: 'nastaveno',
    'shared-with': 'sdíleno s',
    'read-perm': 'zobrazení',
    'write-perm': 'úpravy',
    'execute-perm': 'spuštění',
    permit: 'povolení',
    'of-visualization': 'vizualiaci',
    user: 'uživatel',
    'of-scene': 'scény',
    control: 'ovládat',
    'set-value': 'nastavit hodnotu',
    graph: 'graf',
    'cloud-status': 'stav cloudu',
    table: 'tabulka',
    'clear-selected': 'zrušit výběr',
    'do-set': 'nastavit',
    cancel: 'zrušit',
    'enter-text': 'vložte text',
    'not-available': 'nedostupné',
    'set-project-as-default': 'nastavit projekt {0} jako výchozí',
    'default-project-set': 'výchozí projekt nastaven',
    refresh: 'obnovit',
    enabled: 'povoleno',
    disabled: 'zakázáno',
    last: 'poslední',
    argument: 'argument',
    'choose-datetime-range': 'vyber období',
    'from-date': 'od',
    'to-date': 'do',
    chart: 'graf',
    charts: 'grafy',
    second: 'vteřina',
    minute: 'minuta',
    hour: 'hodina',
    day: 'den',
    week: 'týden',
    month: 'měsíc',
    quarter: 'čtvrtletí',
    year: 'rok',
    'table-view': 'tabulkové zobrazení',
    datetime: 'datum a čas',
    'enter-number': 'vlož číslo',
    'choose-notification-types': 'vyber způsoby notifikování',
    is: 'je',
    'advanced-view': 'pokročilé zobrazení',
    'simple-view': 'zjednodušené zobrazení',
    'notification-settings': 'nastavení notifikace',
    'enable-menu-collapsing': 'povolit zabalování menu',
    menu: 'menu',
    navigation: 'navigace',
    'service-tile-click-navigates-to-next-level': 'klik na dlaždici služby zobrazí zařízení',
    'service-group-tile-click-navigates-to-next-level': 'klik na dlaždici skupiny služeb zobrazí služby',
    'snapshot-build-datetime': 'datum sestavení',
    'new-project-version': 'nová verze projektu',
    'edit-place-name': 'změnit název místa',
    'enter-at-least-x-letters': 'zadej alespoň {count} písmena (bez mezer)',
    'installer-name': 'instalatérský název',
    'edit-service-name': 'změnit název služby',
    'nothing-is-here': 'nic tu není',
    'maybe-you-need-some-permissions': 'možná potřebuješ nějaká oprávnění',
    'username-must-be-valid-email-address': 'uživatelské jméno musí být platná emailová adresa',
    'reload-project': 'obnovit projekt',
    'cloud-connection': 'iCOOL 4 cloud',
    'local-connection': 'přímé spojení v lokální síti',
    'connection-type': 'typ spojení',
    'include-settings': 'zahrnout nastavení',
    'user-api-token-settings': 'nastavení uživatelského API tokenu',
    'obtain-new-auth-token': 'získat nový API token',
    'delete-auth-token': 'smazat API token',
    'token-deleted': 'token smazán',
    'token-obtained': 'token vytvořen',
    created: 'vytvořeno',
    'first-value': 'první hodnota',
    'last-value': 'posl. hodnota',
    paginate: 'stránkovat',
    all: 'vše',
    'number-of-errors': 'počet chyb',
    'services-with-error': 'služby v chybném stavu',
    'add-panel': 'Přidat panel',
    'energo-panel': 'Energo panel',
    help: 'nápověda',
    'metrics-overview-for-date-range': 'přehled metrik pro období',
    'logged-vars-overview': 'přehled metrik',
    'metrics-overview': 'přehled metrik',
    'delete-metrics': 'smazat metriky',
    'delete-to-date': 'smazat uložená data ke dni',
    'copy-argument-link-to-clipboard': 'Zkopírovat argument link do schránky',
    'copied-to-clipboard': 'Zkopírováno do schránky',
    'subscription': 'Placené služby',
    'identification_number': 'IČO',
    'company': 'Firma',
    'street': 'Ulice a číslo',
    'city': 'Město',
    'zip': 'PSČ',
    'country_code': 'Kód země',
    'place-order': 'Objednat',
  },
};
